import { DEFAULT_CURRENCY_PRECISION } from "../constants";

export const formatFloatValueToCurrencyInputValue = (
  value: number | string,
  precision = DEFAULT_CURRENCY_PRECISION
) => {
  let valueAsString = value.toString();

  const [integerPart, decimalPart = ""] = valueAsString.split(".");

  if (decimalPart) {
    valueAsString = `${integerPart
      .padStart(1, "0")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${decimalPart.padEnd(
      precision,
      "0"
    )}`;
  } else {
    valueAsString = `${integerPart
      .padStart(1, "0")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")},${"0".repeat(precision)}`;
  }

  return valueAsString;
};
